import styled from 'styled-components';

export const Address = styled.p`
  margin-top: 0;
  color: #444444;
`;
